import { useTableActionContext } from '@aibees/elephant/context';
import { LabelType } from '@aibees/elephant/types/label';
import { ACCORDION_IDS } from '@aibees/shared/store';
import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo, useEffect, useMemo } from 'react';
import { LabelManagement } from '../search-table-action-dialog-lists/components/label-management';
import * as Styled from './styles';
import * as SX from './sx';
import type { ListLabelActionBulkModalProps as Props } from './types';
import { useTitleValue } from './use-title-value';

export const ListLabelActionBulkModal = memo(
  ({
    className,
    type,
    state,
    firstState,
    optional,
    expandedAccordion,
    setExpandedAccordion,
  }: Props) => {
    const { labels, lists, setLists, setLabels, setPreviousState } =
      useTableActionContext();
    const labelTags = labels.map((label) => label.name).join(', ');
    const listTags = lists.map((list) => list.name).join(', ');
    const tags = type === LabelType.LABEL ? labelTags : listTags;
    const isLabel = type === LabelType.LABEL;
    const length = isLabel ? labels.length : lists.length;
    const leftIcon = useMemo(
      () => (isLabel ? 'label-outline' : 'account-list'),
      [isLabel]
    );
    const titleValue = useTitleValue(isLabel, length, optional);

    const setItems = useMemo(
      () => (isLabel ? setLabels : setLists),
      [isLabel, setLabels, setLists]
    );

    const handleOpenDialog = () => {
      firstState.onFalse();
      state.onTrue();
      setPreviousState(type);
    };

    useEffect(() => {
      if (!state.value) {
        setPreviousState('');
      }
    }, [state.value]);

    return (
      <Styled.Wrapper
        id={`${isLabel ? ACCORDION_IDS.LABEL : ACCORDION_IDS.LIST}`}
        className={classnames('ListLabelActionBulkModal', className)}
        sx={SX.root}
        title={titleValue}
        leftIcon={leftIcon}
        description={tags}
        labelCount={length}
        expandedAccordion={expandedAccordion}
        setExpandedAccordion={setExpandedAccordion}
        descriptionW="360px"
      >
        <Stack direction="row" gap={1} alignContent="center">
          <LabelManagement
            type={type}
            setItems={setItems}
            onOpenDialog={handleOpenDialog}
          />
        </Stack>
      </Styled.Wrapper>
    );
  }
);

ListLabelActionBulkModal.displayName = 'ListLabelActionBulkModal';
